import { render } from "./MsaConfirmPanel.vue?vue&type=template&id=9b7a61aa&scoped=true"
import script from "./MsaConfirmPanel.vue?vue&type=script&lang=js"
export * from "./MsaConfirmPanel.vue?vue&type=script&lang=js"

import "./MsaConfirmPanel.vue?vue&type=style&index=0&id=9b7a61aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7a61aa"]])

export default __exports__